import React from "react";
import { useLocation } from "react-router-dom";

import { useIsMobile, useCurrentAdminPage } from "@hooks";
import { hiddenTitlePages } from "@utils";
import { TopContainer } from "../LayoutWrappers";
import MobileNavigationBar from "../Navigation/MobileNavigationBar";
import PageTitle from "../PageTitle";

const AdminHeader = props => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const pageName = location.pathname.split("/")?.[3];
  const hideTitle = hiddenTitlePages.some(page => pageName?.includes(page));

  if (hideTitle) return null;

  return (
    <TopContainer showBreadcrumbs={false} statusBarDisplayed={props?.showStatusBar}>
      {isMobile && <MobileNavigationBar {...props} useCurrentPage={useCurrentAdminPage} />}
      <PageTitle />
    </TopContainer>
  );
};

export default AdminHeader;
